export const urlapi='https://api.jrpaqueteria.mx'// produccion
//export const urlapi='https://api.jrpaqueteria.mx'// produccion (IP, solo HTTP - rompe si el front va por HTTPS)
//export const urlapi='http://192.168.10.140'// desarrollo Topher 
//export const urlapi='http://192.168.10.201'// desarrollo Diego
//export const urlapi='http://25.27.53.245'// desarrollo Diego hamachi
